import React from 'react';
import { LucideIcon } from 'lucide-react';

interface MetricCardProps {
  title: string;
  value: string | number;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  icon: LucideIcon;
  iconColor: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  trend,
  icon: Icon,
  iconColor
}) => {
  return (
    <div className="relative group">
      <div className="bg-[#111]/90 rounded-[20px] border border-white/[0.08] p-6 transition-all duration-300">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg ${iconColor.replace('text-', 'bg-')}/10`}>
              <Icon className={`w-5 h-5 ${iconColor}`} />
            </div>
            <h3 className="text-base font-medium text-white/80">{title}</h3>
          </div>
          
          {trend && (
            <div className={`text-sm ${
              trend.isPositive ? 'text-green-500/70' : 'text-red-500/70'
            }`}>
              <span className="font-medium">
                {trend.isPositive ? '+' : ''}{trend.value}%
              </span>
            </div>
          )}
        </div>

        {/* Value */}
        <div className="mb-1">
          <span className="text-2xl font-medium tracking-tight">{value}</span>
        </div>
      </div>
    </div>
  );
};
